import { render, staticRenderFns } from "./ContactListItem.vue?vue&type=template&id=2b599dff&scoped=true&"
import script from "./ContactListItem.vue?vue&type=script&lang=ts&"
export * from "./ContactListItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContactListItem.vue?vue&type=style&index=0&id=2b599dff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b599dff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VListItem,VListItemContent,VRow})
